import React from 'react';

import { cn } from '@easydatasolution/ui-react/lib/utils';

import { Image } from './Image/Image';
import type { ImageData } from './Image/Image';
import { Markdown } from './Markdown/Markdown';

interface ImageCardProps {
	title: string;
	text: string;
	image: {
		image: ImageData;
		alt: string;
		title: string;
	};
	className?: string;
}

export const ImageCard = ({ title, text, image, className = '' }: ImageCardProps) => {
	return (
		<article
			className={cn(
				`flex flex-col items-center gap-8 rounded-lg bg-white p-5 text-secondary-700 shadow-lg`,
				className,
			)}
		>
			<Image
				image={image.image}
				alt={image.alt || ''}
				title={image.title}
				draggable={false}
				loading="lazy"
				className="flex-shrink-0"
			/>
			<div className="flex h-full flex-col gap-3">
				<h3 className="text-xl font-semibold">{title}</h3>
				<Markdown content={text} className="flex-grow text-lg text-secondary-700" />
			</div>
		</article>
	);
};
